export const IN_BUILT_CUSTOM_FIELDS_CATEGORY = "In-built Custom Fields";

const normalizeCategory = (value: unknown): string =>
  String(value ?? "")
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "");

export const isInBuiltCustomFieldCategory = (value: unknown): boolean => {
  const normalized = normalizeCategory(value);
  return (
    normalized === normalizeCategory(IN_BUILT_CUSTOM_FIELDS_CATEGORY) ||
    normalized === "internalcustomfields"
  );
};

export const filterCreatableCategoryOptions = <
  T extends { label?: unknown; value?: unknown }
>(
  options: T[]
): T[] =>
  options.filter(
    (option) =>
      !isInBuiltCustomFieldCategory(option.label) &&
      !isInBuiltCustomFieldCategory(option.value)
  );
